/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  CreateMyReferralCodeDTO,
  CreatePartnerReferralCodeDTO,
  GetReferralsMe200,
  GetReferralsMe401,
  GetReferralsValidate200,
  GetReferralsValidate404,
  GetReferralsValidate429,
  GetReferralsValidateParams,
  PatchReferralsMe200,
  PatchReferralsMe400,
  PatchReferralsMe401,
  PatchReferralsMe404,
  PatchReferralsMe409,
  PostAdminReferrals201,
  PostAdminReferrals400,
  PostAdminReferrals403,
  PostAdminReferrals409,
  PostReferralsMe201,
  PostReferralsMe400,
  PostReferralsMe401,
  PostReferralsMe409,
  PostReferralsSignup202,
  PostReferralsSignup404,
  PostReferralsSignup429,
  StartReferralSignupDTO,
  UpdateMyReferralCodeDTO
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Retorna código, link e indicações do usuário logado. `data` é `null` quando o usuário ainda não gerou o código.
 * @summary Obter meu código de indicação
 */
export type getReferralsMeResponse200 = {
  data: GetReferralsMe200
  status: 200
}

export type getReferralsMeResponse401 = {
  data: GetReferralsMe401
  status: 401
}

export type getReferralsMeResponseSuccess = (getReferralsMeResponse200) & {
  headers: Headers;
};
export type getReferralsMeResponseError = (getReferralsMeResponse401) & {
  headers: Headers;
};

export type getReferralsMeResponse = (getReferralsMeResponseSuccess | getReferralsMeResponseError)

export const getGetReferralsMeUrl = () => {


  

  return `https://api.wedofi.com/referrals/me`
}

export const getReferralsMe = async ( options?: RequestInit): Promise<getReferralsMeResponse> => {
  
  return customFetch<getReferralsMeResponse>(getGetReferralsMeUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Vincula um código de indicação ao usuário logado. Aceita um `code` sugerido; sem ele, o código é gerado automaticamente. Cada usuário pode ter apenas um código.
 * @summary Gerar meu código de indicação
 */
export type postReferralsMeResponse201 = {
  data: PostReferralsMe201
  status: 201
}

export type postReferralsMeResponse400 = {
  data: PostReferralsMe400
  status: 400
}

export type postReferralsMeResponse401 = {
  data: PostReferralsMe401
  status: 401
}

export type postReferralsMeResponse409 = {
  data: PostReferralsMe409
  status: 409
}

export type postReferralsMeResponseSuccess = (postReferralsMeResponse201) & {
  headers: Headers;
};
export type postReferralsMeResponseError = (postReferralsMeResponse400 | postReferralsMeResponse401 | postReferralsMeResponse409) & {
  headers: Headers;
};

export type postReferralsMeResponse = (postReferralsMeResponseSuccess | postReferralsMeResponseError)

export const getPostReferralsMeUrl = () => {


  

  return `https://api.wedofi.com/referrals/me`
}

export const postReferralsMe = async (createMyReferralCodeDTO?: CreateMyReferralCodeDTO, options?: RequestInit): Promise<postReferralsMeResponse> => {
  
  return customFetch<postReferralsMeResponse>(getPostReferralsMeUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMyReferralCodeDTO,)
  }
);}
  

/**
 * Troca o código do usuário logado. As indicações já registradas são preservadas (apontam para o id, não para o texto) e quem já foi indicado é movido para o segmento do novo código. **Links já distribuídos com o código antigo deixam de funcionar.**
 * @summary Alterar meu código de indicação
 */
export type patchReferralsMeResponse200 = {
  data: PatchReferralsMe200
  status: 200
}

export type patchReferralsMeResponse400 = {
  data: PatchReferralsMe400
  status: 400
}

export type patchReferralsMeResponse401 = {
  data: PatchReferralsMe401
  status: 401
}

export type patchReferralsMeResponse404 = {
  data: PatchReferralsMe404
  status: 404
}

export type patchReferralsMeResponse409 = {
  data: PatchReferralsMe409
  status: 409
}

export type patchReferralsMeResponseSuccess = (patchReferralsMeResponse200) & {
  headers: Headers;
};
export type patchReferralsMeResponseError = (patchReferralsMeResponse400 | patchReferralsMeResponse401 | patchReferralsMeResponse404 | patchReferralsMeResponse409) & {
  headers: Headers;
};

export type patchReferralsMeResponse = (patchReferralsMeResponseSuccess | patchReferralsMeResponseError)

export const getPatchReferralsMeUrl = () => {


  

  return `https://api.wedofi.com/referrals/me`
}

export const patchReferralsMe = async (updateMyReferralCodeDTO: UpdateMyReferralCodeDTO, options?: RequestInit): Promise<patchReferralsMeResponse> => {
  
  return customFetch<patchReferralsMeResponse>(getPatchReferralsMeUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateMyReferralCodeDTO,)
  }
);}
  

/**
 * Valida um código de indicação. Resultado cacheado por 10 minutos e limitado por IP.
 * @summary Validar código de indicação (público)
 */
export type getReferralsValidateResponse200 = {
  data: GetReferralsValidate200
  status: 200
}

export type getReferralsValidateResponse404 = {
  data: GetReferralsValidate404
  status: 404
}

export type getReferralsValidateResponse429 = {
  data: GetReferralsValidate429
  status: 429
}

export type getReferralsValidateResponseSuccess = (getReferralsValidateResponse200) & {
  headers: Headers;
};
export type getReferralsValidateResponseError = (getReferralsValidateResponse404 | getReferralsValidateResponse429) & {
  headers: Headers;
};

export type getReferralsValidateResponse = (getReferralsValidateResponseSuccess | getReferralsValidateResponseError)

export const getGetReferralsValidateUrl = (params: GetReferralsValidateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/referrals/validate?${stringifiedParams}` : `https://api.wedofi.com/referrals/validate`
}

export const getReferralsValidate = async (params: GetReferralsValidateParams, options?: RequestInit): Promise<getReferralsValidateResponse> => {
  
  return customFetch<getReferralsValidateResponse>(getGetReferralsValidateUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Valida o código, registra a intenção de cadastro e dispara o OTP de e-mail. O usuário é criado quando o OTP for confirmado.
 * @summary Cadastrar visitante por indicação (público)
 */
export type postReferralsSignupResponse202 = {
  data: PostReferralsSignup202
  status: 202
}

export type postReferralsSignupResponse404 = {
  data: PostReferralsSignup404
  status: 404
}

export type postReferralsSignupResponse429 = {
  data: PostReferralsSignup429
  status: 429
}

export type postReferralsSignupResponseSuccess = (postReferralsSignupResponse202) & {
  headers: Headers;
};
export type postReferralsSignupResponseError = (postReferralsSignupResponse404 | postReferralsSignupResponse429) & {
  headers: Headers;
};

export type postReferralsSignupResponse = (postReferralsSignupResponseSuccess | postReferralsSignupResponseError)

export const getPostReferralsSignupUrl = () => {


  

  return `https://api.wedofi.com/referrals/signup`
}

export const postReferralsSignup = async (startReferralSignupDTO: StartReferralSignupDTO, options?: RequestInit): Promise<postReferralsSignupResponse> => {
  
  return customFetch<postReferralsSignupResponse>(getPostReferralsSignupUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startReferralSignupDTO,)
  }
);}
  

/**
 * Cria um código de indicação sem usuário vinculado, para parceiros e campanhas.
 * @summary Criar código de parceiro/campanha (admin)
 */
export type postAdminReferralsResponse201 = {
  data: PostAdminReferrals201
  status: 201
}

export type postAdminReferralsResponse400 = {
  data: PostAdminReferrals400
  status: 400
}

export type postAdminReferralsResponse403 = {
  data: PostAdminReferrals403
  status: 403
}

export type postAdminReferralsResponse409 = {
  data: PostAdminReferrals409
  status: 409
}

export type postAdminReferralsResponseSuccess = (postAdminReferralsResponse201) & {
  headers: Headers;
};
export type postAdminReferralsResponseError = (postAdminReferralsResponse400 | postAdminReferralsResponse403 | postAdminReferralsResponse409) & {
  headers: Headers;
};

export type postAdminReferralsResponse = (postAdminReferralsResponseSuccess | postAdminReferralsResponseError)

export const getPostAdminReferralsUrl = () => {


  

  return `https://api.wedofi.com/admin/referrals`
}

export const postAdminReferrals = async (createPartnerReferralCodeDTO: CreatePartnerReferralCodeDTO, options?: RequestInit): Promise<postAdminReferralsResponse> => {
  
  return customFetch<postAdminReferralsResponse>(getPostAdminReferralsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPartnerReferralCodeDTO,)
  }
);}
  

